import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Button, Col, Container, Row } from 'reactstrap';
import classNames from 'classnames';
import { inject, observer } from 'mobx-react';
import { matchPath, withRouter } from 'react-router';
import RouterPropTypes from 'react-router-prop-types';
import { injectIntl, intlShape } from 'react-intl';

import ContentSlots from '../../ad/ContentSlots';
import AdZones from '../../../types/AdZones';
import MobileNavigationButton from '../MobileNavigationButton';
import MobileNavigationTab from '../../../types/MobileNavigationTab';
import AccountStore from '../../../store/AccountStore';
import UIStore from '../../../store/UIStore';
import ConfigStore from '../../../store/ConfigStore';
import NavigationLogo from '../NavigationLogo';
import QuickSearch from '../../search/QuickSearch';
import NavigationCart from '../NavigationCart';
import { modelOf } from '../../../prop-types';
import Icon from '../../common/Icon';
import Hamburger from '../../common/Hamburger';
import RouteService from '../../../services/RouteService';
import generatePath from '../../../util/generatePath';
import Paths from '../../../types/Paths';
import LicensePlateInput from '../../vehicle/LicensePlateInput';
import { addParametersToPath } from '../../../util/queryString';
import TranslatedImageType from '../../../types/TranslatedImageType';
import TranslationStore from '../../../store/TranslationStore';
import globalTranslations from '../../../i18n/globalTranslations';

@observer
export class CommonNavigationMiddle extends Component {
  desktopCommonNavigation() {
    const { configStore } = this.props;
    const centerShopLogo = configStore.topNavigation.centerShopLogo;
    const showBanner = configStore.topNavigation.moveSearchbarTopNavigation;
    const vehiclePartSearchEnabled = configStore.vehiclePartSearch.enabled;
    return (
      <div
        className={classNames('CommonNavigation__middle-content', {
          'CommonNavigation__middle-content--centered-logo': centerShopLogo
        })}
      >
        {vehiclePartSearchEnabled
          ? this.renderVehicleSearchPartHeader()
          : this.renderNavigationHeader()}
        {showBanner && this.getBannerZone()}
      </div>
    );
  }

  renderNavigationHeader = () => {
    const {
      accountStore,
      configStore,
      hideCheckout,
      ifShouldShowFullHeader,
      inputBlur,
      inputFocus,
      isSticky,
      moveShoppingCartLoginRight,
      onSearchKeyPress,
      useStickyHeaderOnStartup
    } = this.props;

    const showCart = !accountStore.isViewOnly;
    const centerShopLogo = configStore.topNavigation.centerShopLogo;

    return (
      <Fragment>
        {centerShopLogo && <div />}
        <NavigationLogo
          sticky={isSticky}
          useStickyHeaderOnStartup={useStickyHeaderOnStartup}
          ifShouldShowFullHeader={ifShouldShowFullHeader}
        />
        {!configStore.siteConfig.isHomePage &&
          !centerShopLogo && (
            <div
              className={classNames('CommonNavigation__middle-right-content', {
                'CommonNavigation__middle-only-content': !showCart,
                'CommonNavigation__middle-center-content':
                  configStore.topNavigation.center
              })}
            >
              <div className="CommonNavigation__middle-right-content-top">
                {!configStore.topNavigation.moveSearchbarTopNavigation && (
                  <QuickSearch
                    handleFocus={inputFocus}
                    handleBlur={inputBlur}
                    toggleSearch={onSearchKeyPress}
                  />
                )}
                {showCart &&
                  moveShoppingCartLoginRight &&
                  configStore.siteConfig.isWebStore && (
                    <NavigationCart withCheckoutButton={hideCheckout} />
                  )}
              </div>
            </div>
          )}
      </Fragment>
    );
  };

  renderVehicleSearchPartHeader = () => {
    const {
      accountStore,
      configStore,
      uiStore,
      hideCheckout,
      inputBlur,
      inputFocus,
      isSticky,
      moveShoppingCartLoginRight,
      onSearchKeyPress,
      useStickyHeaderOnStartup
    } = this.props;

    const showCart = !accountStore.isViewOnly;
    const vehiclePartSearchEnabled =
      configStore.vehiclePartSearch.enabled && uiStore.isHD;
    const centerShopLogo = configStore.topNavigation.centerShopLogo;

    return !centerShopLogo ? (
      <Row className="CommonNavigation__middle-content-row">
        <Col
          md={centerShopLogo ? 8 : 3}
          xl={centerShopLogo ? 8 : 4}
          className="pl-0"
        >
          {centerShopLogo && <div />}
          <NavigationLogo
            sticky={isSticky}
            useStickyHeaderOnStartup={useStickyHeaderOnStartup}
          />
        </Col>
        <Col
          md={9}
          xl={8}
          className={classNames('CommonNavigation__middle-right-content', {
            'CommonNavigation__middle-only-content': !showCart,
            'CommonNavigation__middle-center-content':
              configStore.topNavigation.center
          })}
        >
          <div className="CommonNavigation__license-plate-input">
            {!configStore.topNavigation.moveSearchbarTopNavigation && (
              <LicensePlateInput
                handleOnSubmit={this.handleVehicleSearch}
                clearAfterSubmit
                hideSearchButtonText={vehiclePartSearchEnabled}
              />
            )}
          </div>
          <div className="CommonNavigation__middle-right-content-top">
            {!configStore.topNavigation.moveSearchbarTopNavigation && (
              <QuickSearch
                handleFocus={inputFocus}
                handleBlur={inputBlur}
                toggleSearch={onSearchKeyPress}
                vehiclePartSearchEnabled={vehiclePartSearchEnabled}
              />
            )}
            {showCart &&
              moveShoppingCartLoginRight &&
              configStore.siteConfig.isWebStore && (
                <NavigationCart
                  withCheckoutButton={hideCheckout}
                  className={'NavigationCart__vehicle-search-part'}
                  wrapperClassName={
                    'NavigationCart__vehicle-search-part-cart-button-wrapper'
                  }
                />
              )}
          </div>
        </Col>
      </Row>
    ) : (
      this.renderNavigationHeader()
    );
  };

  getBannerZone = () => (
    <div className="CommonNavigation__content-slots CommonNavigation__content-slots__container">
      <ContentSlots
        searchParams={{
          bannerZone: AdZones.HEADER_CONTENT
        }}
        className="CommonNavigation__content-slots"
      />
    </div>
  );

  mobileCommonNavigation = () => {
    const {
      accountStore,
      configStore,
      uiStore,
      hideCheckout,
      inputBlur,
      inputFocus,
      intl,
      onSearchKeyPress,
      onShowSearchOnMobile,
      shouldShowSearchOnMobile
    } = this.props;

    const showCart = !accountStore.isViewOnly;
    const vehiclePartSearchEnabled = configStore.vehiclePartSearch.enabled;
    const mobileSearchbarVisibility =
      configStore.topNavigation.headerMobileSearchbarVisibility;
    const visibleMobileSearchbar =
      shouldShowSearchOnMobile || mobileSearchbarVisibility;
    const hideMobileContainer = uiStore.searchIsActive;

    return (
      <div className="CommonNavigation__middle-content">
        <Container className="CommonNavigation__middle-content-container">
          {!hideMobileContainer && (
            <Row
              className={classNames('CommonNavigation__mobile-container-row', {
                'CommonNavigation__mobile-container-row--hidden': hideMobileContainer
              })}
            >
              <Col xs={12} className="CommonNavigation__mobile-container">
                <MobileNavigationButton
                  tab={this.getDefaultMobileMenuTab()}
                  withBorder
                  forceClose={uiStore.mobileNavigation.isOpen}
                  ariaLabel={intl.formatMessage(
                    globalTranslations.seeCategoriesNavi
                  )}
                >
                  <Hamburger active={uiStore.mobileNavigation.isOpen} />
                </MobileNavigationButton>
                <div className="CommonNavigation__mobile-right">
                  <Link to="/">
                    <Button
                      color="plain"
                      className="CommonNavigation__mobile-home"
                      aria-label={intl.formatMessage(
                        globalTranslations.homeTitle
                      )}
                    >
                      {this.getMobileLogoUrl() ? (
                        <img
                          alt={configStore.store.name}
                          src={this.getMobileLogoUrl()}
                        />
                      ) : (
                        <Icon name="home" className="fa-2x" />
                      )}
                    </Button>
                  </Link>
                  {!configStore.siteConfig.isHomePage &&
                    !mobileSearchbarVisibility && (
                      <Button
                        color="plain"
                        onClick={onShowSearchOnMobile}
                        aria-label={intl.formatMessage(
                          globalTranslations.search
                        )}
                      >
                        <Icon name="search" className="fa-2x" />
                      </Button>
                    )}
                  {this.getMobileIconForAccountIfWebStore()}
                  {this.getMobileIconForWishListIfShoppingCentreAndEnabled()}
                  {configStore.storeInfoPageId > 0 && (
                    <Button
                      color="plain"
                      onClick={this.navigateToStoreInfoPage}
                      aria-label={intl.formatMessage(
                        globalTranslations.infoTitle
                      )}
                    >
                      <Icon name="map-marker" className="fa-2x" />
                    </Button>
                  )}
                  {showCart &&
                    configStore.siteConfig.isWebStore && (
                      <NavigationCart withCheckoutButton={hideCheckout} />
                    )}
                </div>
              </Col>
            </Row>
          )}
          {visibleMobileSearchbar && (
            <Row
              className={classNames('CommonNavigation__mobile-search-row', {
                'CommonNavigation__mobile-search-row--no-padding': hideMobileContainer,
                'CommonNavigation__mobile-search-row--show': visibleMobileSearchbar
              })}
            >
              {vehiclePartSearchEnabled && (
                <Col sm={{ size: 6, offset: 6 }} className="mb-2">
                  <LicensePlateInput
                    handleOnSubmit={this.handleVehicleSearch}
                    clearAfterSubmit
                    hideSearchButtonText={!uiStore.isTablet}
                  />
                </Col>
              )}
              <Col sm={12}>
                <QuickSearch
                  handleFocus={inputFocus}
                  handleBlur={inputBlur}
                  toggleSearch={onSearchKeyPress}
                />
              </Col>
            </Row>
          )}
        </Container>
      </div>
    );
  };

  getDefaultMobileMenuTab = () => {
    const { location } = this.props;

    if (
      matchPath(location.pathname, {
        path: '/:locale?' + Paths.InfoPage
      })
    ) {
      return MobileNavigationTab.INFO;
    }

    return MobileNavigationTab.PRODUCTS;
  };

  getMobileLogoUrl = () => {
    const { translationStore } = this.props;
    const logo = translationStore.translatedImages.find(
      (image) => image.image_key === TranslatedImageType.STORE_MOBILE_LOGO
    );
    return logo && logo.image_path;
  };

  getMobileIconForAccountIfWebStore = () => {
    const { intl, configStore } = this.props;

    return (
      configStore.siteConfig.isWebStore && (
        <MobileNavigationButton
          tab={MobileNavigationTab.ACCOUNT}
          className="ml-auto text-uppercase"
          ariaLabel={intl.formatMessage(globalTranslations.myAccountTitle)}
        >
          <Icon name="user" className="fa-2x" />
        </MobileNavigationButton>
      )
    );
  };

  getMobileIconForWishListIfShoppingCentreAndEnabled = () => {
    const { intl, configStore } = this.props;

    return (
      configStore.wishlist.enabled &&
      configStore.siteConfig.isShoppingCenter && (
        <MobileNavigationButton
          tab={MobileNavigationTab.ACCOUNT}
          className="ml-auto text-uppercase"
          ariaLabel={intl.formatMessage(globalTranslations.seeCategoriesNavi)}
        >
          <Icon name="star" className="fa-2x" />
        </MobileNavigationButton>
      )
    );
  };

  navigateToStoreInfoPage = () => {
    const { configStore, routeService } = this.props;

    const storeInfoPagePath = generatePath(Paths.InfoPage, {
      slug: '-',
      id: configStore.storeInfoPageId
    });
    this.props.history.push(routeService.getPath(storeInfoPagePath));
  };

  handleVehicleSearch = (licensePlate) => {
    const { routeService, history } = this.props;
    const licensePlateUrl = licensePlate
      ? addParametersToPath(Paths.VehiclePartSearch, {
          id: licensePlate
        })
      : Paths.VehiclePartSearch;
    const url = routeService.getPath(licensePlateUrl);

    history.push(url);
  };

  render() {
    const { uiStore } = this.props;

    return uiStore.isDesktop
      ? this.desktopCommonNavigation()
      : this.mobileCommonNavigation();
  }
}

CommonNavigationMiddle.propTypes = {
  accountStore: modelOf(AccountStore).isRequired,
  configStore: modelOf(ConfigStore).isRequired,
  translationStore: modelOf(TranslationStore).isRequired,
  uiStore: modelOf(UIStore).isRequired,
  routeService: PropTypes.instanceOf(RouteService).isRequired,
  intl: intlShape.isRequired,
  location: RouterPropTypes.location.isRequired,
  hideCheckout: PropTypes.bool.isRequired,
  isSticky: PropTypes.bool.isRequired,
  moveShoppingCartLoginRight: PropTypes.bool.isRequired,
  shouldShowSearchOnMobile: PropTypes.bool.isRequired,
  inputBlur: PropTypes.func.isRequired,
  inputFocus: PropTypes.func.isRequired,
  onSearchKeyPress: PropTypes.func.isRequired,
  onShowSearchOnMobile: PropTypes.func.isRequired,
  ifShouldShowFullHeader: PropTypes.bool,
  useStickyHeaderOnStartup: PropTypes.bool
};

export default inject(
  'accountStore',
  'configStore',
  'translationStore',
  'uiStore',
  'routeService'
)(withRouter(injectIntl(CommonNavigationMiddle)));



// WEBPACK FOOTER //
// ./src/components/header/CommonNavigationMiddle/index.jsx